import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms'
@Component({
  selector: 'app-add-tik-num',
  templateUrl: './add-tik-num.component.html',
  styleUrls: ['./add-tik-num.component.scss']
})
export class AddTikNumComponent implements OnInit {

  @Input() qID: number = null;
  @Input() public titles: string[];
  @Input() public index: number;
  @Input() public tikNum: FormGroup;
  @Output() public removed: EventEmitter<number> = new EventEmitter<number>();
  @Input() public displayErrors: boolean;
  @Input() public ph: string[];
  @Input() public displayX: boolean;


  defaultValue = "";

  
  
  constructor() { }

  ngOnInit() {
	
  }

  static buildTikNum(val: any) {
    return new FormGroup({
    internalTikNum: new FormControl(val[0]? val[0].answerValue : "")
	});
}
  
}



// WEBPACK FOOTER //
// ./src/app/add-tik-num/add-tik-num.component.ts